// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__bFk77","button":"Button_button__6d0Ru"};